import { useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";

const input = "w-full border border-[#e2dcd4] bg-white px-3 py-2.5 text-sm focus:outline-none focus:border-[#1f402b]";
const label = "block font-mono-k text-[10px] uppercase tracking-widest text-[#5a665e] mb-1.5";

export default function ProfileForm({ seller, onSaved }) {
  const [f, setF] = useState({ business_name: seller?.business_name || "", region: seller?.region || "", about: seller?.about || "", website: seller?.website || "" });
  const [saving, setSaving] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const save = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const { data } = await api.put("/seller/profile", f);
      toast.success("Profile saved");
      onSaved(data);
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setSaving(false);
    }
  };
  return (
    <form onSubmit={save} className="border border-[#e2dcd4] bg-white p-6 sm:p-8 space-y-4" data-testid="seller-profile-form">
      <p className="eyebrow">Your seller profile</p>
      <div><span className={label}>Business or seller name</span><input required minLength={2} value={f.business_name} onChange={set("business_name")} className={input} data-testid="seller-business-name" /></div>
      <div className="grid sm:grid-cols-2 gap-4">
        <div><span className={label}>Region</span><input value={f.region} onChange={set("region")} placeholder="e.g. Waikato" className={input} data-testid="seller-region" /></div>
        <div><span className={label}>Website (optional)</span><input value={f.website} onChange={set("website")} placeholder="https://" className={input} data-testid="seller-website" /></div>
      </div>
      <div><span className={label}>About you (optional)</span><textarea rows={3} value={f.about} onChange={set("about")} className={input} data-testid="seller-about" /></div>
      <button disabled={saving} className="bg-[#1f402b] text-white px-6 py-2.5 text-sm hover:bg-[#2c5a3d] disabled:opacity-60" data-testid="seller-profile-save">{saving ? "Saving…" : "Save profile"}</button>
    </form>
  );
}
